import { useClientExperiment } from '../hooks/use-client-experiment';
import { useExperiment } from '../hooks/use-experiment';

export function usePricingExperimentVariant() {
  const serverVariant = useExperiment()?.topaz;
  const { variant: clientVariant, isLoading } = useClientExperiment('topaz', {
    enabled: !serverVariant,
    pathRegex: /^\/experience$/,
  });
  return {
    variant: serverVariant ?? clientVariant ?? undefined,
    isLoading: !serverVariant && isLoading,
  };
}
